import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const UnlockIcon = ({
  size = 24,
  sx,
  color,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.57145 11.3571V7.92857C8.57145 6.03502 10.1065 4.5 12 4.5C13.8936 4.5 15.4286 6.03502 15.4286 7.92857V8.5M6.28574 11.3571H17.7143C18.3455 11.3571 18.8572 11.8688 18.8572 12.5V19.3571C18.8572 19.9883 18.3455 20.5 17.7143 20.5H6.28574C5.65456 20.5 5.14288 19.9883 5.14288 19.3571V12.5C5.14288 11.8688 5.65456 11.3571 6.28574 11.3571Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
